import React, { lazy, Suspense } from 'react';
import BannerSection from "../../components/BannerSection";
import { Loader } from '../../components/Loader';
import MetaTags from '../../components/MetaTags';
import { imagePath } from '../../Utils/WHL/helpers';
const Body = lazy(() => import('../../components/Body'));

const USDAPage = ({
    pageDetails
}) => {
    return (
        <>
            <MetaTags
                url={process.env.REACT_APP_USDA_PRODUCTS}
                ogImagePath={`${imagePath}/previewImages/usda_preview.jpg`}
                keywords={'USDA, USDA Loans, Homeownership, Home Loan, Loan, Loans, Mortgage, Home Loans, Homebuyer, Low FICO, Zero Down Payment'}
                description={'Do you live in a rural area? Are you having trouble obtaining a conventional loan? Apply for a USDA Loan at Sun West and get up to 100% financial assistance with no down payment option! Visit https://usda.swmc.com/ today to learn more!'}
            />
            <BannerSection pageDetails = { pageDetails } />
            <Suspense fallback={<Loader />}>
                <Body pageDetails = { pageDetails } />
            </Suspense>
        </>
    );
}
 
export default USDAPage;